/* Lotus Wheel time-comparison card — clocks animate in on scroll:
   hands sweep into place, the gauge bezel fills and its flag pops.
   Progressive enhancement (final state already correct without JS);
   skipped for reduced motion. */
class TimeReveal extends HTMLElement {
  connectedCallback() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    this.classList.add('is-armed');
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          this.classList.add('is-revealed');
          this.observer.disconnect();
        }
      },
      { threshold: 0.3 }
    );
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }
}

customElements.define('time-reveal', TimeReveal);
